import * as React from "react"

import * as st from './IconBlock.styled.js'

const IconBlock = ({
  className,
  Icon,
}) => (
  <st.Wrap
    className={className}
  >
    <Icon />
  </st.Wrap>
)

export default IconBlock
